import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Admin from "./Admin";
import History from "./History"; // ????? ????? ?????????? ?????????
import DriverPage from "./DriverPage";
import MonitPage from "./MonitPage";
import './index.css';
import SettingsPage from "./SettingsPage";
import ConfigPage from "./ConfigPage";
import Navbar from "./Navbar";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";


function handleLogout() {
  const auth = getAuth();
  signOut(auth).then(() => {
    window.location.href = "/";
  });
}

function AppLayout() {
  const [user, setUser] = useState(undefined);
  const [isEditMode, setIsEditMode] = useState(false);
  const [siteName, setSiteName] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const docRef = doc(db, "settings", "siteName");
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setSiteName(doc.data().name);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      {user && <Navbar onLogout={handleLogout} isEditMode={isEditMode} setIsEditMode={setIsEditMode} siteName={siteName} />}
      <div>
        <Routes>
          {/*     .-App     shopId  */}
          <Route path="/shop/:shopId" element={<App isEditMode={isEditMode} setIsEditMode={setIsEditMode} />} />

          {/*    (  ) */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/history" element={<History />} />
          <Route path="/driver" element={<DriverPage />} />
          <Route path="/monit" element={<MonitPage />} />
          
          
          {/*   .      App, 
                       */}
          <Route path="/" element={<App isEditMode={isEditMode} setIsEditMode={setIsEditMode} />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/config" element={<ConfigPage />} />
        </Routes>
      </div>
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AppLayout />
  </BrowserRouter>
);
